<!--
 * @Descripttion: 
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-07-18 17:01:14
 * @LastEditors: alex.yang
 * @LastEditTime: 2022-07-20 11:27:46
-->
<template>
    <div class="housingTypeManagement">
        <div class="title-wrap">
            <div class="tag"></div>
            <div class="title">小区列表</div>
        </div>
        <div class="case-wrap">
            <communityManagement ref="communityManagement"></communityManagement>
        </div>
    </div>
</template>

<script>
import pageMixin from '@/internal/pageMixin'
import communityManagement from './htComponents/communityManagement'
export default {
    components:{
        communityManagement,
    },
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'housingTypeManagement',
            activeName: 'first',
        }
    },
    mounted () {

    },
    methods: {

    },
}
</script>

<style lang='scss'>
.housingTypeManagement{
    background: rgb(240, 242, 245);
    padding: 10px 25px;
    height: calc(100vh - 80px);
    overflow-y: auto;
    .title-wrap{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 5px 0;
        .tag{
        width: 4px;
        height: 20px;
        background: #409EFF;
        border-radius: 10px;
        }
        .title{
        font-size: 18px;
        font-weight: bold;
        padding-left: 10px;
        }
    }
    .case-wrap{
        background: #fff;
        padding: 20px;
        margin: 20px 0;
        border-radius: 6px;
    }
}
</style>
